export default "__VITE_ASSET__3e956c6f__"